import { render, staticRenderFns } from "./BuyBar.vue?vue&type=template&id=f164f344&"
import script from "./BuyBar.vue?vue&type=script&lang=js&"
export * from "./BuyBar.vue?vue&type=script&lang=js&"
import style0 from "./BuyBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports